import { useTranslation } from 'react-i18next';

export default function Guide() {
  const { t } = useTranslation();
  const steps: string[] = t('guidePage.campfireCheckin.flow.steps', { returnObjects: true });

  return (
    <div className="surface-body">
      <h1>{t('guidePage.title')}</h1>

      {/* Non-closable warning/note */}
      <div className="note" role="note" aria-live="polite">
        <h2>{t('guidePage.introTitle')}</h2>
        <p style={{ margin: 0 }}>{t('guidePage.introBody')}</p>
      </div>

      {/* Clickable, boxy accordion */}
      <details className="accordion">
        <summary>{t('guidePage.campfireCheckin.title')}</summary>
        <div className="accordion-body">
          <section style={{ marginTop: 4 }}>
            <h3 style={{ margin: '6px 0' }}>{t('guidePage.campfireCheckin.discover.title')}</h3>
            <p>{t('guidePage.campfireCheckin.discover.p1')}</p>
            <p>{t('guidePage.campfireCheckin.discover.p2')}</p>
          </section>

          <section style={{ marginTop: 10 }}>
            <h3 style={{ margin: '6px 0' }}>{t('guidePage.campfireCheckin.window.title')}</h3>
            <p>{t('guidePage.campfireCheckin.window.p1')}</p>
          </section>

          <section style={{ marginTop: 10 }}>
            <h3 style={{ margin: '6px 0' }}>{t('guidePage.campfireCheckin.rewards.title')}</h3>
            <p>{t('guidePage.campfireCheckin.rewards.p1')}</p>
          </section>

          <section style={{ marginTop: 10 }}>
            <h3 style={{ margin: '6px 0' }}>{t('guidePage.campfireCheckin.flow.title')}</h3>
            <ol style={{ marginTop: 4, paddingLeft: '1.2rem' }}>
              {steps.map((s, i) => <li key={i} style={{ margin: '6px 0' }}>{s}</li>)}
            </ol>
          </section>

        </div>
      </details>

      {/* Quick Pokémon Search accordion */}
      <details className="accordion" style={{ marginTop: 10 }}>
        <summary>{t('guidePage.quickSearch.title')}</summary>
        <div className="accordion-body">
          <p>{t('guidePage.quickSearch.p1')}</p>
          <p>{t('guidePage.quickSearch.p2')}</p>
          <a
            href="/searchguide"
            className="link"
            style={{ color: '#1e90ff', fontWeight: 600 }}
          >
            {t('guidePage.quickSearch.link')}
          </a>
        </div>
      </details>

      {/* Friend & Interaction Search accordion */}
      <details className="accordion" style={{ marginTop: 10 }}>
        <summary>{t('guidePage.peopleSearch.title')}</summary>
        <div className="accordion-body">
          <p>{t('guidePage.peopleSearch.p1')}</p>
          <p>{t('guidePage.peopleSearch.p2')}</p>
          <a
            href="/peoplesearch"
            className="link"
            style={{ color: '#1e90ff', fontWeight: 600 }}
          >
            {t('guidePage.peopleSearch.link')}
          </a>
        </div>
      </details>


    </div>
  );
}
